import { CheckSquare, Check } from "lucide-react";
import { LockedSection } from "@/components/plan/common";

export default function WeeklyChecklistSection({ checklist, locked, checked, onToggle }) {
  if (!checklist) return null;
  return (
    <LockedSection locked={locked} icon={CheckSquare} title="Weekly optimization checklist">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {["week_1", "week_2", "week_3", "week_4"].map((wk, i) => (
          <div key={wk} className="bg-white border border-zinc-200 rounded-2xl p-5">
            <div className="text-xs uppercase tracking-widest text-zinc-500">Week {i + 1}</div>
            <ul className="mt-3 space-y-2 text-sm">
              {checklist[wk]?.map((t, j) => {
                const key = `wk_${i}_${j}`;
                const done = !!checked[key];
                return (
                  <li key={`wkitem-${wk}-${j}-${t.slice(0, 20)}`} className="flex items-start gap-2">
                    <button
                      onClick={() => !locked && onToggle(key)}
                      disabled={locked}
                      className={`h-4 w-4 rounded border-2 shrink-0 mt-0.5 flex items-center justify-center ${
                        done ? "bg-emerald-500 border-emerald-500" : "border-zinc-300 hover:border-indigo-500"
                      }`}
                    >
                      {done && <Check className="h-2.5 w-2.5 text-white" />}
                    </button>
                    <span className={done ? "line-through text-zinc-400" : "text-zinc-800"}>{t}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </LockedSection>
  );
}
